import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AuthProvider } from '@/features/auth/hooks/useAuth'
import { TooltipProvider } from "@/components/ui/tooltip"
import { AppRouter } from '@/lib/router'

// ─────────────────────────────────────────────────────────────
// Query client configuration
// Aggressive stale times reduce redundant network calls.
// The user sees stale data while revalidation happens in the bg.
// ─────────────────────────────────────────────────────────────

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,   // 2 min before considered stale
      gcTime: 1000 * 60 * 10,  // 10 min before removed from cache
      retry: 1,
      refetchOnWindowFocus: false,        // don't refetch on tab switch
    },
    mutations: {
      retry: 0,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <AppRouter />
        </TooltipProvider>
      </AuthProvider>
      {import.meta.env.DEV && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom" />
      )}
    </QueryClientProvider>
  )
}
